import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import OfficeService from '../../../Services/OfficeService';

// Trivial placeholder: the wizard only instantiates windowDescription.itemType when no
// editedItem prop is passed. OfficeAdmin always passes the selected office (crudType=Update),
// so this is never invoked, but it keeps the windowDescription contract satisfied.
class OfficeCorporateCostsEditItem {}

export default class EditOfficeCorporateWindowDescription {
  static titleForEdit = (item) => `Edit Corporate Costs Information (${item.Name})`;
  static itemType = OfficeCorporateCostsEditItem;
  static finishButtonLabel = 'Save Office';
  static messageOnSuccess = 'Office has been saved.';

  // Mirrors the old panel's clickOnSubmitButton: the whole edited office object is posted back
  // (OfficeService.EditOffice string-converts and PUTs the entire office). MUST return the
  // promise (wizard contract).
  static serviceFunction = (edited) => OfficeService.EditOffice(edited);

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'PayrollTaxPct',
          label: 'Pricing Payroll Tax %',
          className: 'col-6',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'EmpBenefitsDailyCost',
          label: 'Pricing Benefits %',
          className: 'col-6',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'CpaPayrollTaxPct',
          label: 'CPA Payroll Tax %',
          className: 'col-6',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'CpaEmpBenefitsPct',
          label: 'CPA Employee Benefits %',
          className: 'col-6',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'MarkupPercentage',
          label: 'Markup %',
          className: 'col-6',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
      ],
    },
  ];
}
